import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["name", "control", "rules", "defaultValue", "containerClassName", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { JOVE_PRICE_UNIT_CURRENCY_KEY, JOVE_PRICE_UNIT_PERCENT_KEY } from '../../constants/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var JovePriceUnitRadioGroup = function JovePriceUnitRadioGroup(props) {
  var width = props.width,
      currencySymbol = props.currencySymbol,
      defaultValue = props.defaultValue,
      value = props.value,
      valueChange = props.valueChange,
      textSize = props.textSize,
      disabled = props.disabled,
      currencyNativeSymbol = props.currencyNativeSymbol;

  var _useState = useState([{
    value: JOVE_PRICE_UNIT_CURRENCY_KEY,
    label: '£'
  }, {
    value: JOVE_PRICE_UNIT_PERCENT_KEY,
    label: '%'
  }]),
      unitList = _useState[0],
      setUnitList = _useState[1];

  var _useState2 = useState(value || defaultValue || ''),
      selectUnit = _useState2[0],
      setSelectUnit = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    if (currencySymbol) {
      setUnitList(unitList.map(function (item) {
        if (item.value === JOVE_PRICE_UNIT_CURRENCY_KEY) {
          item.label = currencySymbol;
        }

        return _objectSpread({}, item);
      }));
    }
  }, [currencySymbol]);
  useEffect(function () {
    setSelectUnit(value);
  }, [value]);
  useEffect(function () {
    if (currencyNativeSymbol) {
      setUnitList(unitList.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          label: item.value === JOVE_PRICE_UNIT_CURRENCY_KEY ? currencyNativeSymbol : item.label
        });
      }));
    }
  }, [currencyNativeSymbol]);
  /**
   * methods
   */

  var selectAction = function selectAction(item) {
    if (disabled) {
      return;
    }

    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item.value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-row space-x-2",
    children: unitList.map(function (item) {
      return /*#__PURE__*/_jsx(Box, {
        className: clsx('flex items-center justify-center rounded-md', item.value === selectUnit ? 'bg-brand-secondary' : 'border-grey-10 border', disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'),
        sx: {
          width: width,
          height: width
        },
        onClick: function onClick() {
          return selectAction(item);
        },
        children: /*#__PURE__*/_jsx(Typography, {
          className: clsx('font-bold', item.value === selectUnit ? 'text-white' : 'text-grey-50'),
          sx: {
            fontSize: textSize !== null && textSize !== void 0 ? textSize : '16px'
          },
          children: item.label
        })
      }, item.value);
    })
  });
};
export var JovePriceUnitRadioGroupControlled = function JovePriceUnitRadioGroupControlled(props) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JovePriceUnitRadioGroup, _objectSpread(_objectSpread({}, rest), {}, {
      value: value,
      valueChange: valueChangeAction
    }))
  });
};